import { makeStyles } from "@fluentui/react";
import { IPanelEditarIncidente } from "../editarIncidente/PanelEditarIncidente";
import { Warning24Filled } from "@fluentui/react-icons";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { Body1 } from "@fluentui/react-components";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { useCallback } from "react";
import { UsePanelOcultoIncidente } from "./UsePanelOcultoIncidente";
const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export const PanelOcultoIncidente=(props:IPanelEditarIncidente)=>{
    const styles = useStyles();
    const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelOcultoIncidente(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto={props.item.esOculto?"Habilitar":"Ocultar"}
              texto2={"Salir"}
              onClick={putEditarCatalogo}
              onDismiss={() => {
                reset()
              }}
            />
          </>
        ),
        [request]
      );
    return (
        <PanelDrawer
          isOpen={props.isOpen}
          onDismiss={reset}   
          textHeader={props.item.esOculto?"Habilitar Elemento":"Ocultar Elemento"}
          status={status}
          mensaje={mensaje}
          loading={loading}
          onRenderFooter={onRenderFooter}
        >
         <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          ¿Desea 
                             {props.item.esOculto?" habilitar":" ocultar"} el Incidente: {props.item.nombreGrupoIncidente}?
                        </Body1>
                      </div>
                    </div>
                  </>
       </PanelDrawer>
    )
}